import React from 'react';
import {
  Tabs,
  Tab,
} from '@material-ui/core';
import {
  getQueryParam,
  setQueryParam,
} from '../../../utils/urlHelper';
import Page from '../../widgets/Page';
import StatusSettings from '../StatusSettings';
import TagSettings from '../TagSettings';
import EventDataSettings from '../EventDataSettings';

const getTabContent = (tab) => {
  switch (tab) {
    case 0:
      return StatusSettings;
    case 1:
      return EventDataSettings;
    case 2:
      return TagSettings;
    default:
      return StatusSettings;
  }
};

export class EventSettingsComponent extends React.Component {
  constructor(props) {
    super(props);

    const queryParamTab = getQueryParam('tab')
      ? parseInt(getQueryParam('tab'), 10)
      : 0;
    this.state = { selectedTab: queryParamTab };
    setQueryParam('tab', queryParamTab);
  }

  handleChangeTab = (event, value) => {
    this.setState({ selectedTab: value });
    setQueryParam('tab', value);
  }

  render() {
    const Component = getTabContent(this.state.selectedTab);

    return (
      <Page
        title="Event Settings"
        disableToolbarPadding
        toolbar={(
          <Tabs
            value={this.state.selectedTab}
            onChange={this.handleChangeTab}
            indicatorColor="secondary"
            textColor="inherit"
            variant="scrollable"
            scrollButtons="on"
          >
            <Tab label="Statuses" />
            <Tab label="Custom Fields" />
            <Tab label="Tags" />
          </Tabs>
        )}
      >
        <Component />
      </Page>
    );
  }
}

export default EventSettingsComponent;
